import React from 'react';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_ATTRIBUTE_SELECTION } from 'utils/mixpanelEventNames';

interface props {
    index: any;
    allCheckedAttribute: any;
    item: any;
    attributeType: any;
    onClickCheckbox: Function;
    setAllCheckedAttribute: Function;
    dimension: any;
    allSelectedValueForAllAttribute: any;
    attributeNames: any;
}

function FilterAttrNameList({
    index,
    allCheckedAttribute,
    item,
    attributeType,
    onClickCheckbox,
    setAllCheckedAttribute,
    dimension,
    allSelectedValueForAllAttribute,
    attributeNames,
}: props) {
    return (
        <li key={index} className={'mx-3 mt-2'}>
            <label className="font-sm flex gap-2 items-center cursor-pointer" key={index}>
                <div className="min-w-4 min-h-4">
                    <input
                        type={'checkbox'}
                        className={'checkbox-size accent-purpleFont'}
                        value={
                            allCheckedAttribute?.[attributeType.name] &&
                            item.attributeExId in allCheckedAttribute?.[attributeType.name]
                        }
                        checked={
                            allCheckedAttribute?.[attributeType.name]
                                ? item.attributeExId in allCheckedAttribute?.[attributeType.name]
                                : false
                        }
                        onChange={(e) => {
                            onClickCheckbox(
                                item,
                                e,
                                attributeType.name,
                                setAllCheckedAttribute,
                                allCheckedAttribute,
                                dimension,
                                allSelectedValueForAllAttribute,
                                attributeNames,
                            );
                            //mixpanel event
                            trackEventMixpanel(GLOBAL_FILTER_ATTRIBUTE_SELECTION, {
                                attributeType: item?.attributeType,
                                attributeName: item?.attributeExId,
                                dimension: item?.dimension,
                                isChecked: e.target.checked,
                            });
                        }}
                        disabled={!item.isActive}
                    />
                </div>
                <span className={`font-xs ml-2 ${!item.isActive ? 'text-fontGreyAlt' : ''}`}>{item.attributeExId}</span>
            </label>
        </li>
    );
}

export default FilterAttrNameList;
